import type { ProviderDetail } from '../../../../../js/api';
import {
  fileCountFor,
  formatFileCount,
  labelsFor,
  ProviderDrawerMaps,
  EMPTY_VALUE,
} from './providerDisplay';
import { FieldSection, FieldSpec } from './ProviderDrawerPrimitives';

/**
 * `ProviderFileType` codes of the pure-file education collections the old tab
 * listed as downloads. Only the count is shown here; labels come from the
 * `ProviderFileType` CodeDefinition category.
 */
export const EDUCATION_FILE_TYPES = [
  'MEDICAL_DIPLOMA',
  'INTERNSHIP',
  'RESIDENCY_CERTIFICATE',
  'FELLOWSHIP_CERTIFICATE',
  'ECFMG',
  'CME',
] as const;

/** Languages and education document counts — the old "Education" tab. */
export function EducationTab({
  provider,
  maps,
}: {
  provider: ProviderDetail;
  maps: ProviderDrawerMaps;
}) {
  const languages = provider.languages_spoken || [];
  const languageFields: FieldSpec[] = [
    {
      label: 'Languages Spoken',
      stackLabel: true,
      value: languages.length ? (
        <ul className="tw:list-none tw:p-0 tw:m-0 tw:!pl-0">
          {languages.map((code) => (
            <li key={code}>{labelsFor([code], maps.Language)}</li>
          ))}
        </ul>
      ) : (
        EMPTY_VALUE
      ),
    },
  ];

  const documentFields: FieldSpec[] = EDUCATION_FILE_TYPES.map((fileType) => ({
    label: maps.ProviderFileType?.[fileType] || fileType,
    value: formatFileCount(fileCountFor(provider.file_counts, fileType)),
  }));

  return (
    <div className="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-x-3 tw:gap-y-4">
      <FieldSection title="Languages" fields={languageFields} />
      <FieldSection
        title="Education Documents"
        fields={documentFields}
        data-testid="provider-education-documents"
      />
    </div>
  );
}
